import { PIPELINE_LABELS, STAGE_STATUS_LABELS } from "@/lib/organs";

const COLORS = {
  completed: "#10B981",
  processing: "#06B6D4",
  requires_confirmation: "#F59E0B",
  blocked: "#EF4444",
  failed: "#EF4444",
  pending: "#4B5563",
  not_applicable: "#374151",
};

export default function PipelineStepper({ pipeline = [], detailed = false }) {
  const byStage = Object.fromEntries((pipeline || []).map((s) => [s.stage, s]));
  const stages = Object.keys(PIPELINE_LABELS);
  return (
    <div data-testid="pipeline-stepper">
      <div className="flex items-center">
        {stages.map((st, i) => {
          const s = byStage[st];
          const status = s?.status || "pending";
          const color = COLORS[status] || COLORS.pending;
          return (
            <div key={st} className="flex items-center flex-1 last:flex-none">
              <span
                data-testid={`pipeline-stage-${st}`}
                title={`${PIPELINE_LABELS[st]}: ${STAGE_STATUS_LABELS[status] || status}${s?.reason ? " — " + s.reason : ""}`}
                className={`w-2.5 h-2.5 rounded-full shrink-0 ${status === "processing" ? "animate-pulse" : ""}`}
                style={{
                  background: status === "not_applicable" ? "transparent" : color,
                  border: `1.5px ${status === "not_applicable" ? "dashed" : "solid"} ${color}`,
                  boxShadow: ["completed", "blocked"].includes(status) ? `0 0 6px ${color}` : "none",
                }}
              />
              {i < stages.length - 1 && <span className="h-px flex-1 bg-white/10" />}
            </div>
          );
        })}
      </div>
      {detailed && (
        <div className="mt-3 space-y-1.5">
          {stages.map((st) => {
            const s = byStage[st];
            const status = s?.status || "pending";
            return (
              <div key={st} className="flex items-start gap-2 text-[11px]" data-testid={`pipeline-detail-${st}`}>
                <span className="w-1.5 h-1.5 rounded-full mt-1.5 shrink-0" style={{ background: COLORS[status] }} />
                <span className="text-gray-400 w-28 shrink-0">{PIPELINE_LABELS[st]}</span>
                <span className="text-gray-500">
                  <span style={{ color: COLORS[status] }}>{STAGE_STATUS_LABELS[status] || status}</span>
                  {s?.result ? ` · ${s.result}` : ""}
                  {s?.reason ? ` · ${s.reason}` : ""}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
